import { Button } from '@/components/ui/button'
import { Input } from '@/components/ui/input'
import { Label } from '@/components/ui/label'
import { useState, useEffect } from 'react'
import { toast } from '@/components/ui/use-toast'

const Account = () => {
  const [name, setName] = useState("");
  const [companyName, setCompanyName] = useState("");

  useEffect(() => {
    const user = localStorage.getItem("user");
    if (user) {
      const userData = JSON.parse(user);
      setName(userData.full_name || "");
    }
    setCompanyName(localStorage.getItem("companyName") || "");
  }, []);

  const handleUpdateAccount = () => {
    localStorage.setItem("companyName", companyName);
    toast({
      title: "Account Updated",
      description: "Your company account has been updated successfully.",
    });
  };

  return (
    <>
        <div>
            <h2 className="text-2xl font-bold tracking-tight">Accounts</h2>
            <p className="text-muted-foreground">
              Manage your accounts details.
            </p>
        </div>

        <hr className='my-4' />

        <div className="flex flex-col gap-y-8">
            <div className="">
                <Label htmlFor="name" className="text-gray-700">
                    Name
                </Label>
                <Input
                    id="name"
                    className="max-w-[300px] mt-2 h-8"
                    placeholder='Your name'
                    value={name}
                    onChange={(e) => setName(e.target.value)}
                />
                <Label className="text-gray-500 text-xs">
                    This is the name that will be displayed on your receipts after checkout.
                </Label>
            </div>

            <div className="">
                <Label htmlFor="companyName" className="text-gray-700">
                    Company Name
                </Label>
                <Input
                    id="companyName"
                    className="max-w-[300px] mt-2 h-8"
                    placeholder='Company name'
                    value={companyName}
                    onChange={(e) => setCompanyName(e.target.value)}
                />
                <Label className="text-gray-500 text-xs">
                    This is the name that will be displayed across all your branches.
                </Label>
            </div>

            <Button
                className='max-w-[300px]'
                onClick={handleUpdateAccount}
            >
                Update Account
            </Button>
        </div>
    </>
  )
}

export default Account